// import TemplatePointers from "./components/TemplatePointers"
function LandingIntro() {
  return (
    <div className="hero min-h-full rounded-l-xl bg-base-200">
      <div className="hero-content py-12">
        <div className="max-w-md">
          <h1 className="text-3xl text-center font-bold ">
            <img
              src="/logo192.png"
              className="w-12 inline-block mr-2 mask mask-circle"
              alt="dashwind-logo"
            />
            SynthLife
          </h1>
          {/* <img src={comma} className="bg-none" /> */}
          
          <div className="text-7xl font-bold relative mt-5">
            <span className="absolute top-0 left-0">“</span>
          </div>
          <div className="font-bold mt-16">
            <h1 className="">Pieter</h1>
            <p className="text-4xl  tracking-wide leading-normal">
              ...easiest platform to create a unique face and quality content...
            </p>
          </div>

          {/* <div className="text-center mt-12"><img src="./intro.png" alt="Dashwind Admin Template" className="w-64 inline-block rounded-xl"></img></div> */}

          {/* Importing pointers component */}
          {/* <TemplatePointers /> */}
        </div>
      </div>
    </div>
  );
}

export default LandingIntro;
